document.addEventListener("DOMContentLoaded", () => {
  const optionsContainer = document.querySelector(".send-glasses-data-options");
  const manualInput = document.getElementById(
    "send_glasses_data_enter_manually"
  );
  const uploadInput = document.getElementById("send_glasses_data_upload_photo");
  const manualValuesSection = document.querySelector(
    ".prescription-values-insert-manually"
  );
  const uploadSection = document.querySelector("#uploadery");
  const completeAllFieldsText = document.querySelector(".complete_all_fields");
  const manualFieldsContainer = document.querySelector(
    ".prescription-values-insert-manually-options"
  );

  if (
    !optionsContainer ||
    !manualInput ||
    !manualValuesSection ||
    !manualFieldsContainer ||
    !uploadInput ||
    !uploadSection
  )
    return;

  const inputs = optionsContainer.querySelectorAll("input");
  let uploadObserver;

  const toggleVisibility = () => {
    manualValuesSection.classList.toggle("hidden", !manualInput.checked);
    uploadSection.classList.toggle("hidden", !uploadInput.checked);
  };

  const resetManualFields = () => {
    window.single_vison.manually_added_values = {};
    window.single_vison.completed_manually_added_values = false;
    if (completeAllFieldsText) completeAllFieldsText.classList.remove("hidden");

    manualFieldsContainer.querySelectorAll(".selectBox").forEach((box) => {
      const selected = box.querySelector(".selected");
      const placeholder = selected?.getAttribute("data-placeholder");
      const defaultValue = box.getAttribute("data-default-value");
      const template = document
        .querySelector(".product-page")
        .getAttribute("template");

      const is_mandatory_box =
        box.id !== "_cylinder_left" &&
        box.id !== "_cylinder_right" &&
        box.id !== "_axis_left" &&
        box.id !== "_axis_right" &&
        !(
          box.id === "_birthdate" &&
          !(template === "varifocal" || template === "sunglasses-varifocal")
        );

      if (defaultValue && defaultValue.trim() !== "") {
        const optionItems = box.querySelectorAll(".selectOption");
        const match = Array.from(optionItems).find(
          (opt) => opt.getAttribute("value") === defaultValue
        );
        if (match) {
          selected.textContent = match.textContent;
          box.setAttribute("data-value", defaultValue);
        }
      } else {
        if (is_mandatory_box) {
          box.classList.add("incomplete");
        }
        box.setAttribute("data-value", "");
        if (selected && placeholder) selected.textContent = placeholder;
      }
    });
  };

  const getUploaderyPropertyInputs = () => {
    const uploadContainer = document.querySelector("#uploadery-container") || uploadSection;
    if (!uploadContainer) return [];

    return Array.from(
      uploadContainer.querySelectorAll('input[name^="properties["]')
    );
  };

  const hasUploadedFiles = () => {
    const uploaderyInputs = getUploaderyPropertyInputs();
    if (uploaderyInputs.some((input) => input.value && input.value.trim() !== "")) {
      return true;
    }

    const fileUrlInput = document.getElementById("file_url");
    return !!(fileUrlInput && fileUrlInput.value && fileUrlInput.value.trim() !== "");
  };

  const syncUploadReadyState = () => {
    const hasFiles = hasUploadedFiles();
    if (window.single_vison.ready_to_add_to_cart !== hasFiles) {
      window.single_vison.ready_to_add_to_cart = hasFiles;
    }
  };

  const observeUploadList = () => {
    const uploadContainer = document.querySelector("#uploadery-container") || uploadSection;
    if (!uploadContainer) return;
    if (uploadObserver) uploadObserver.disconnect();

    uploadObserver = new MutationObserver(syncUploadReadyState);

    uploadObserver.observe(uploadContainer, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["value", "name", "class"],
    });

    uploadContainer.addEventListener("change", syncUploadReadyState);
    uploadContainer.addEventListener("input", syncUploadReadyState);
    syncUploadReadyState();
  };

  const allManualFieldsCompleted = () => {
    const boxes = manualFieldsContainer.querySelectorAll(".selectBox");
    for (const box of boxes) {
      const is_mandatory_box =
        box.id !== "_cylinder_left" &&
        box.id !== "_cylinder_right" &&
        box.id !== "_axis_left" &&
        box.id !== "_axis_right" &&
        box.id !== "_pupil_distance"

      if (is_mandatory_box && box.classList.contains("incomplete")) {
        const incomplete_values = document.querySelectorAll(
          ".selectBox.incomplete"
        );
        if (incomplete_values.length === 1 || incomplete_values.length === 0) {
          return true;
        } else {
          return false;
        }
      }
    }
    return true;
  };

  const onManualInputChange = () => {
    const allCompleted = allManualFieldsCompleted();
    window.single_vison.ready_to_add_to_cart = allCompleted;
  };

  toggleVisibility();

  inputs.forEach((input) => input.addEventListener("change", toggleVisibility));

  function setupSelectOptions() {
    if (window.single_vison.prescription_values_method !== 0) {
      window.single_vison.ready_to_add_to_cart = false;
    }

    resetManualFields();

    if (window.single_vison.prescription_values_method === 1) {
      const allCompleted = allManualFieldsCompleted();
      window.single_vison.ready_to_add_to_cart = allCompleted;
    }

    document.querySelectorAll(".selectOption").forEach((option) => {
      option.addEventListener("click", () => {
        onManualInputChange();
      });
    });
  }

  inputs.forEach((input, index) => {
    input.addEventListener("change", () => {
      window.single_vison.prescription_values_method = index;

      if (index !== 2 && uploadObserver) {
        uploadObserver.disconnect();
      }

      if (index === 0) {
        window.single_vison.ready_to_add_to_cart = true;
      } else if (index === 1) {
        window.single_vison.ready_to_add_to_cart = false;
        resetManualFields();
      } else if (index === 2) {
        window.single_vison.ready_to_add_to_cart = hasUploadedFiles();
        observeUploadList();
      } else if (index === 3) {
        window.single_vison.ready_to_add_to_cart = true;
      }
    });
  });

  setupSelectOptions();

  const initialMethod = window.single_vison.prescription_values_method;
  if (inputs[initialMethod]) {
    inputs[initialMethod].checked = true;
  }

  toggleVisibility();

  if (window.single_vison.prescription_values_method === 2) {
    window.single_vison.ready_to_add_to_cart = hasUploadedFiles();
    setTimeout(() => {
      observeUploadList();
    }, 500);
  }

  if (window.single_vison.prescription_values_method === 3) {
    window.single_vison.ready_to_add_to_cart = true;
  }
});
